module.exports = __webpack_public_path__ + "img/dj.f02dcd39.png";